// Tabs
var tabs = document.querySelectorAll('ul.tabs');
tabs.forEach(function(tabList) {
    var tabs = tabList.querySelectorAll('a');
    tabs.forEach(function(tab) {
        tab.addEventListener('click', function(e) {
            var contentLocation = this.getAttribute('href');
            if (contentLocation.charAt(0) === "#") {
                e.preventDefault();
                tabs.forEach(function(t) {
                    t.classList.remove('active');
                });
                this.classList.add('active');
                var parentTabs = this.closest('ul.tabs');
                var contentToShow = parentTabs.nextElementSibling.querySelector(contentLocation);
                contentToShow.style.display = 'block';
                contentToShow.classList.add('active');
                var siblings = contentToShow.parentElement.children;
                for (var i = 0; i < siblings.length; i++) {
                    if (siblings[i] !== contentToShow) {
                        siblings[i].style.display = 'none';
                        siblings[i].classList.remove('active');
                    }
                }
            }
        });
    });
});